




























































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { addUserRoles, AddUserRolesRequest } from '@front-app/services/CommunityApi/CommunityReportsApi';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { Size } from '@front-app/components/constants';
import { ALL_USER_ROLES, ALL_USER_ROLE_LABELS, UserClientRoleApi } from '@front-app/services/UserApi/UserModel';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		ConfirmationModal,
		CtaButton,
		ErrorCard,
		SlidingPanel,
		SuccessCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		userIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup(props, ctx) {
		const availableRoles = computed(() => ALL_USER_ROLES
			.map((role) => ({
				key: role,
				label: ctx.root.$t(ALL_USER_ROLE_LABELS[role]) as unknown as string,
			})));
		const selectedRoles: Ref<UserClientRoleApi[]> = ref([] as UserClientRoleApi[]);
		const toggleRole = (role: UserClientRoleApi) => {
			if (selectedRoles.value.includes(role)) {
				selectedRoles.value = selectedRoles.value.filter((selectedRole) => selectedRole !== role);
			} else {
				selectedRoles.value = selectedRoles.value.concat(role);
			}
		};

		// Submission
		const addRolesConfirmation = useConfirmDialog();
		const {
			clear,
			isError,
			isLoading,
			isSuccess,
			track,
		} = useAsyncStatus();
		const addRoles = async () => {
			const { isCanceled } = await addRolesConfirmation.reveal();
			if (isCanceled) {
				return;
			}
			const payload: AddUserRolesRequest = {
				roles: selectedRoles.value,
				userIds: props.userIds,
			};
			await track(addUserRoles(payload));
		};
		const clearAndClose = () => {
			ctx.emit('close');
			clear(0);
			selectedRoles.value = [];
		};

		return {
			ALL_USER_ROLE_LABELS,
			availableRoles,
			selectedRoles,
			toggleRole,
			addRolesConfirmation,
			addRoles,
			isError,
			isLoading,
			isSuccess,
			clearAndClose,
			// Util
			ButtonPalettes,
			DropdownPosition,
			Size,
		};
	},
});
